import React, { Component, Fragment } from 'react';
import { Form, Overlay, OverlayTrigger, Popover } from 'react-bootstrap';

import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import InputMask from 'react-input-mask';

import { stringToDate } from '../utils/formatador';
import { dateToString } from '../utils/formatador';

registerLocale(ptBR);

class DateInput extends Component {
    constructor(props, context) {
        super(props, context);
        let dateString = props.value ? dateToString(props.value) : null;

        this.state = {
            displayValue: dateString ? dateString : '',
            value: !props.value ? null : new window.Date(props.value),
            showCalendar: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleDatePick = this.handleDatePick.bind(this);
    }

    componentDidUpdate(oldProps) {
        const { value } = this.props;
        if(oldProps.value !== value) {
            let dateString = value && dateToString(value);
            this.setState({
                ...this.state,
                displayValue: dateString ? dateString : '',
                value: value
            });
        }
    }

    handleInputChange(e) {
        const { id, name, onChange } = this.props;
        let value = e.target.value;
        let dateValue = stringToDate(value);
        this.setState({
            ...this.state,
            displayValue: value,
            value: dateValue,
        }, () => {
            if(onChange) 
                onChange({ target: { id, name, value: this.state.value ? this.state.value : undefined }});
        });
    }

    handleInputFocus(e) {
        this.setState({
            ...this.state,
            showCalendar: true,
            target: e.target,
            value: stringToDate(e.target.value)
        }); 
    }

    handleInputBlur(e) {
        // this.setState({
        //     ...this.state,
        //     showCalendar: false
        // });
    }

    handleDatePick(date) {
        const { id, name, onChange } = this.props;
        
        //Clear hours of date
        date = new Date(date);
        date.setHours(12);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        this.setState({
            ...this.state,
            displayValue: dateToString(date),
            value: date,
            showCalendar: false
        }, () => {
            if(onChange) 
               onChange({ target: { id, name, value: this.state.value ? this.state.value : undefined }});
        });
    }

    render () {
        const { className, isInvalid, disabled, minDate, maxDate, filterDate, placement = "auto"} = this.props;
        const { displayValue, showCalendar, target, value } = this.state;

        return (
            <OverlayTrigger rootClose trigger={["click"]} placement="auto"
                overlay={
                    <Popover>
                        <Popover.Content className="p-0">
                            <DatePicker selected={value} className="border-0" inline dateFormat="dd/MM/yyyy" locale="pt-BR" showYearDropdown 
                                onChange={this.handleDatePick} filterDate={filterDate}
                                minDate={minDate} maxDate={maxDate}   
                            />
                        </Popover.Content>
                    </Popover>
                }
            >
                <Form.Control as={InputMask} value={displayValue} className={`form-control ${className}`} mask="99/99/9999" 
                    isInvalid={isInvalid} pattern="[0-9]" disabled={disabled}
                    onChange={this.handleInputChange} onFocus={this.handleInputFocus} onBlur={this.handleInputBlur}/>
            </OverlayTrigger>
        );
    }
}

export default DateInput;